<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>Works</md-icon>
                    </div>
                    <h4 class="title">Add Work</h4>
                </md-card-header>

                <form @submit.prevent="add">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="work.name"/>
                                    <validation-error :errors="apiValidationErrors.name"/>
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Call ID
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="work.call_id"/>
                                    <validation-error :errors="apiValidationErrors.call_id"/>
                                </md-field>
                            </div>
                        </div>


                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Vessel
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <multiselect v-model="work.vessel_id" :options="work.vessel_options" :custom-label="name" placeholder="Select Vessel" label="name" track-by="name"></multiselect>
                                    <pre class="language-json"><code>{{ value  }}</code></pre>
<!--                                    <md-select v-model="work.vessel_id" name="vessel_id">-->
<!--                                        <md-option-->
<!--                                                v-for="vessel in available_vessels_dropdown"-->
<!--                                                :key="vessel.id"-->
<!--                                                :value="vessel.id"-->
<!--                                        >-->
<!--                                            {{ vessel.name }}-->
<!--                                        </md-option>-->
<!--                                    </md-select>-->
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Guidance
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <multiselect v-model="work.guidance_id" :options="work.guidance_options" :custom-label="name" placeholder="Select Guidance" label="name" track-by="name"></multiselect>
                                    <pre class="language-json"><code>{{ value  }}</code></pre>
<!--                                    <md-select v-model="work.guidance_id" name="guidance_id">-->
<!--                                        <md-option-->
<!--                                                v-for="guidance in available_guidances_dropdown"-->
<!--                                                :key="guidance.id"-->
<!--                                                :value="guidance.id"-->
<!--                                        >-->
<!--                                            {{ guidance.name }}-->
<!--                                        </md-option>-->
<!--                                    </md-select>-->
                                </md-field>
                            </div>
                        </div>

                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add Work</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
import Multiselect from 'vue-multiselect';

export default {
    components: { ValidationError,Multiselect },

    mixins: [formMixin],

    data: () => ({

        work: {
            type: 'works',
            name: null,
            call_id: null,
            //  vessel_id: null,
            vessel_id: { id: null, name: 'Select Vessel' },
            vessel_options: {},
            //  guidance_id: null,
            guidance_id: { id: null, name: 'Select Guidance' },
            guidance_options: {},
        },
        // available_vessels_dropdown: [],
        // available_guidances_dropdown: [],
    }),
    created () {
        this.getVesselDropDowns();
        this.getGuidanceDropDowns();
    },
    methods: {
        name ({ id, name }) {
            return `${name}`;
        },
        async add () {
            try {
                await this.$store.dispatch('works/add', this.work);
                this.notifySuccess('Work added successfully.');
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].title);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },
        getVesselDropDowns () {
            this.$store.dispatch('vessels/list').then(() => {
                this.work.vessel_options = this.$store.getters['vessels/dropdown'];
                // if (this.available_vessels_dropdown && this.available_vessels_dropdown.length) {
                //     this.work.vessel_id = this.available_vessels_dropdown[0].id;
                // }
            });
        },
        getGuidanceDropDowns () {
            this.$store.dispatch('guidances/list').then(() => {
                console.log(this.$store);
                this.work.guidance_options = this.$store.getters['guidances/dropdown'];
                // if (this.available_guidances_dropdown && this.available_guidances_dropdown.length) {
                //     this.work.guidance_id = this.available_guidances_dropdown[0].id;
                // }
            });
        },
        goBack () {
            this.$router.push({ name: 'Works List' });
        },
    },
};
</script>
